import processing_activities_messages from 'messages/processing_activities_messages';

export const IS_DPIA_TEMPORARILY_DISABLED = true;

export const getDpiaFeatureDisabledTooltip = (t: (message: string | string[]) => string): string =>
  t(processing_activities_messages.dpia.feature_temporarily_unavailable);
